module.exports = __webpack_public_path__ + "img/battle-ropes.0d82f274.jpg";